import {
  configureStore,
  type ThunkAction,
  type Action,
} from "@reduxjs/toolkit";
import appSlice from "./slices/appSlice";
import inboxSlice from "./slices/inboxSlice";
import backgroundSlice from "./slices/backgroundSlice";
import purchasesSlice from "../components/Pages/Purchases_new/store/purchasesSlice";
import userSlice from "./slices/userSlice";
import storage from "redux-persist/lib/storage";
import {
  persistStore,
  persistReducer,
  type PersistConfig,
} from "redux-persist";
import { combineReducers } from "redux";
import {
  adIdViewCountsTransform,
  searchParamsTransform,
} from "./persistorTransforms";
import DevTools from "../components/Structure/Page/components/DevTools";

// Configure the persist settings
const persistConfig: PersistConfig<ReturnType<typeof rootReducer>> = {
  key: "root",
  storage, // Storage method (localStorage for web)
  transforms: [adIdViewCountsTransform, searchParamsTransform],
  whitelist: ["background", "inbox"], // Reducers to persist
};

const rootReducer = combineReducers({
  app: appSlice,
  background: backgroundSlice,
  inbox: inboxSlice,
  user: userSlice,
  purchases: purchasesSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store with persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: true,
  // custom domain issue
  // devTools: process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE.trim() !== 'prod', // Disable the default Redux DevTools extension
  // enhancers: (getDefaultEnhancers) =>
  //   getDefaultEnhancers().concat(DevTools.instrument()),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
